module.exports = __webpack_public_path__ + "img/marker.19a943b3.png";